import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import StateSiteUserPublisher from "./StateSiteUserPublisher";
import Pagination from "../../partials/content/Pagination";

export default function AllSite() {
  const [userAllSitePublisher, setUserAllSitePublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [urlWebSitePublisherSearchFilter, setUrlWebSitePublisherSearchFilter] =
    useState();

  useEffect(() => {
    getUserAllSitePublisher();
  }, [currentPage, urlWebSitePublisherSearchFilter]);

  const getUserAllSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allSiteUserPublisher = await sendRequestGetAllSiteUserPublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allSiteUserPublisher) {
      return;
    }

    setUserAllSitePublisher(allSiteUserPublisher.site_publisher);
    setCountPage(allSiteUserPublisher.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (urlWebSitePublisherSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&url=${urlWebSitePublisherSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllSiteUserPublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let allSiteUserAdvertiser;
    try {
      allSiteUserAdvertiser = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/publisher/site/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allSiteUserAdvertiser.data.data;
  };

  const generateDoNotHaveSitePublisher = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img
            className="img-fluid"
            src="/assets/img/do-not-have-website-publisher.svg"
          />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> شما در حال حاضر هیچ سایت نمایش دهنده فعال ندارید :(</p>
          <p> برای شروع کار یک سایت نمایش دهنده بسازید.</p>
          <p>
            <Link to="/site/add" className="btn btn-success">
              <span className="pl-2">
                <i className="fa fa-plus"> </i>
              </span>
              <span>اضافه کردن سایت نمایش دهنده</span>
            </Link>
          </p>
        </div>
      </div>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateTableSitePublisher = () => {
    return (
      <>
        <div className="alert alert-warning">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                سایت شما در صورتی فعال میشود که اولین جایگاه تبلیغاتی برای آن
                سایت توسط شما اضافه شود و اپراتور آنرا تایید کند.
              </p>
            </li>
          </ul>
        </div>

        <div class="container-fluid pb-3">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در آدرس سایت </label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="آدرس سایت را در اینجا وارد کنید"
                  onKeyUp={(e) =>
                    setUrlWebSitePublisherSearchFilter(e.target.value)
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>آدرس</td>
                <td>وضعیت</td>
                <td>حالت</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {userAllSitePublisher.map((userSitePublisher, index) => {
                let classNameBadgeType = "";
                switch (userSitePublisher.state) {
                  case StateSiteUserPublisher.statusSiteUserPublisher.PENDING:
                    classNameBadgeType += "warning";
                    break;
                  case StateSiteUserPublisher.statusSiteUserPublisher.CONFIRM:
                    classNameBadgeType = "success";
                    break;
                  case StateSiteUserPublisher.statusSiteUserPublisher.REJECT:
                    classNameBadgeType = "danger";
                    break;
                }

                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>{helpersNumbers.toPersianNum(userSitePublisher.id)}</td>
                    <td className="text-left">
                      <a target="_blank" href={userSitePublisher.url}>
                        {userSitePublisher.url}
                      </a>
                    </td>
                    <td>
                      <span className={`badge  badge-${classNameBadgeType}`}>
                        {userSitePublisher.state}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`
                        badge badge-${
                          userSitePublisher.active ==
                          StateSiteUserPublisher.getActiveSiteUserPublisherString()[
                            StateSiteUserPublisher.activeSiteUserPublisher
                              .ACTIVE
                          ]
                            ? "success"
                            : "danger"
                        }
                        `}
                      >
                        {userSitePublisher.active}
                      </span>
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        userSitePublisher.created_at.split(" ")[1] +
                          " " +
                          helpersTime.convertGregorianToJalali(
                            userSitePublisher.created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      <Link
                        className="btn btn-info"
                        to={`/site/info/${userSitePublisher.id}`}
                      >
                        <i className="fa fa-info"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
        <div className="pt-2">
          <Link to="/site/add" className="btn btn-success">
            <span className="pl-2">
              <i className="fa fa-plus"> </i>
            </span>
            <span>اضافه کردن سایت نمایش دهنده</span>
          </Link>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar activeItem="all-my-site-menu" />

      <div className="content-wrapper">
        <TitleBar title="سایت ها نمایش دهنده شما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {userAllSitePublisher.length === 0 &&
              urlWebSitePublisherSearchFilter == null
                ? generateDoNotHaveSitePublisher()
                : generateTableSitePublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
